export const FETCH_LATEST_FEED = 'FETCH_LATEST_FEED';
export const LATES_CLICK_MEDIATYPE = 'LATES_CLICK_MEDIATYPE';
export const FETCH_FACEBOOK_LATEST_FEED = 'FETCH_FACEBOOK_LATEST_FEED';
export const FETCH_NEWS_LATEST_FEED = 'FETCH_NEWS_LATEST_FEED';
export const FETCH_LATES_REPLIES_LATEST_FEED = 'FETCH_LATES_REPLIES_LATEST_FEED';
export const FETCH_INSTANT_NEWS_LATEST_FEED = 'FETCH_INSTANT_NEWS_LATEST_FEED';
export const CHECK_SOURCE_GROUP = 'CHECK_SOURCE_GROUP';
export const CHECK_SUBJECT_ID = 'CHECK_SUBJECT_ID';
export const FETCH_INSTANT_NEWS_SOURCE_GROUP = 'FETCH_INSTANT_NEWS_SOURCE_GROUP'
export const FETCH_INSTANT_NEWS_SOURCE_GROUP_SUCCESS = 'FETCH_INSTANT_NEWS_SOURCE_GROUP_SUCCESS'


export const fetchLatestFeed = (action) => ({
  type: FETCH_LATEST_FEED,
  action
})

export const fetchNewsLatestFeed = (action) => ({
  type: FETCH_NEWS_LATEST_FEED,
  action
})

export const fetchFacebookLatestFeed = (action) => ({
  type: FETCH_FACEBOOK_LATEST_FEED,
  action
})

export const fetchInstantNewsLatestFeed = (action) => ({
  type: FETCH_INSTANT_NEWS_LATEST_FEED,
  action
})

export const fetchInstantNewsSourceGroup = (data) => ({
  type: FETCH_INSTANT_NEWS_SOURCE_GROUP,
  data
})
export const fetchInstantNewsSourceGroupSuccess = (data) => ({
  type: FETCH_INSTANT_NEWS_SOURCE_GROUP_SUCCESS,
  data
})

export const fetchLatesRepliesLatestFeed = (action) => ({
  type: FETCH_LATES_REPLIES_LATEST_FEED,
  action
})

export const latesClickMediaType = (mediaType) => ({
  type: LATES_CLICK_MEDIATYPE,
  mediaType
})

export const checkSourceGroup = (sourceGroup) => ({
  type: CHECK_SOURCE_GROUP,
  sourceGroup
})
export const checkSubject = (subjectId) => ({
  type: CHECK_SUBJECT_ID,
  subjectId
})



/** WEBPACK FOOTER **
 ** ./src/app/modules/home/actions.js
 **/